import React, { useState } from "react";
import { Plus } from "lucide-react";
import { faqs } from "../data";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="faq" id="faq">
      <div className="container">
        <div className="section-label">Частые вопросы</div>
        <h2 className="section-title">Ответы на вопросы, которые вы боитесь задать врачу</h2>
        <p className="section-subtitle">
          Если не нашли свой — спросите на консультации. Мы никогда не торопим с решением.
        </p>

        <div className="faq-wrap">
          <div className="faq-list">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={i} className={`faq-item ${open ? "open" : ""}`} data-testid={`faq-item-${i}`}>
                  <button
                    className="faq-q"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span>{f.q}</span>
                    <span className="faq-toggle">
                      <Plus size={18} />
                    </span>
                  </button>
                  <div className="faq-a">
                    <div className="faq-a-inner">{f.a}</div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="faq-photo">
            <img src="/clinic/doctor-portrait.jpg" alt="Врач клиники" loading="lazy" />
            <div className="faq-photo-caption">
              <div className="faq-photo-title">Получите ответ от врача</div>
              <div className="faq-photo-text">Запишитесь на личную консультацию — обсудим ваш случай и составим план лечения</div>
              <a href="#final" className="btn btn-teal btn-block" data-testid="faq-photo-cta" style={{ marginTop: 16 }}>
                Записаться
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
